import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input } from '@angular/core';
import { Campaign } from '@campaign-portal/namespace/entities/campaigns/specs';
import { AlarisIconDirective, AlarisTooltipDirective, ChannelUtilsService } from '@campaign-portal/components-library';

import { CampaignsService } from '../../../services/campaigns.service';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MessageTemplatePipe } from '@helpers/repo/repo.pipe';
import { exist, Id } from '@campaign-portal/namespace/common/id';
import { Router } from '@angular/router';

@Component({
	selector: 'app-campaign',
	templateUrl: './campaign.component.html',
	styleUrls: ['./campaign.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslateModule, AlarisIconDirective, AlarisTooltipDirective, MessageTemplatePipe],
	standalone: true,
})
export class CampaignComponent {
	@Input() campaign!: Campaign;

	readonly destroyRef = inject(DestroyRef);

	constructor(
		public readonly cu: ChannelUtilsService,
		public readonly campaignsService: CampaignsService,
		private readonly router: Router
	) {}

	export(id: string, fileName?: string): void {
		this.campaignsService.export(id, fileName).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
	}

	navigateToTemplate(templateID: Id<exist> | undefined): void {
		void this.router.navigate(['campaigns', 'templates'], {
			queryParams: {
				templatesTabs: 'campaignTemplates',
				templateID,
			},
		});
	}
}
